import { CustomEvents } from '../../../../services/custom-events';
import { strEndsWith, strTrimSpaces } from '../../../../services/strings';
import { eID } from '../dom';
import { $id } from '../jquery-utils';

// TODO: Clean up & remove jQuery

export default class InputField {
    public el: HTMLInputElement;
    public $JQuery: JQuery;
    public $JQueryAll: JQuery;

    public readonly id: string;
    private _prevInput: string = '';
    private changeSubscribers: Array<(x: string) => void> = [];

    constructor(id: string, removeSpacesOnFocusOut: boolean = false) {
        this.id = id;
        this.el = eID(id);
        this.$JQuery = $id(`${this.id}`);
        this.$JQueryAll = this.$JQuery;
        this.$JQuery.change(() => this.triggerChange());
        if (removeSpacesOnFocusOut) {
            this.$JQuery.focusout(() => this.triggerFocusOut(event as FocusEvent, removeSpacesOnFocusOut));
        }

        // TODO: Move
        if (id !== 'searchButton') {
            this.$JQuery.on('focusout', () => {
                CustomEvents.sendEvent('RemoveGlobalError');
            });
        }
    }

    public underline(isValid: boolean): void {
        this.clearUnderline();
        this.$JQuery.addClass(isValid ? 'valid' : 'invalid');
    }

    public clearUnderline(): void {
        this.$JQuery.removeClass('valid').removeClass('invalid');
    }

    public isEmpty = () => this.val() === '';

    public hasChanged(): boolean {
        const input = (this.$JQuery.val() as string).trim(),
            changed = input !== this._prevInput.trim();

        if (changed) this._prevInput = input;
        return changed;
    }

    public get value() {
        const value = this.$JQuery.val() as string | null || '';
        return value.trim();
    }

    public set value(x: string) {
        this.$JQuery.val(x);
    }

    protected val(value?: string): string {
        if (value) {
            this.$JQuery.val(value);
            return value;
        } else {
            return (this.$JQuery.val() as string).trim();
        }
    }

    public onChange(handler: (value: string) => void): void {
        this.changeSubscribers.push(handler);
    }

    protected triggerChange(): void {
        const newVal = this.value;
        this.changeSubscribers.forEach(s => s(newVal));
    }

    protected triggerFocusOut(event: FocusEvent, removeSpacesOnFocusOut: boolean) {
        const input = (event.target as HTMLInputElement).value as string;
        removeSpacesOnFocusOut ? this.val(strTrimSpaces(input)) : this.val(input);
    }

    public isReturn = () => strEndsWith(this.id, 'Return');
    public getPreviousValue = () => this._prevInput.trim();
    public equals = (field: InputField) => field.id === this.id;
    public toString = () => this.id;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/assets/scripts/services/input-fields/input-field.ts